import { sortAlphabeticallyByProps } from '@ftr/contracts/shared/ArrayUtils'
import { State } from '@ftr/contracts/shared/State'
import { SelectItem } from '@ftr/forms'

export function getSupportedStatesAsSelectItems(
  supportedStates: State[],
  countryCode: string,
  stateCaption: string = 'State/Province/Territory/Country (Optional)',
  addEmptyValue: boolean = true,
): SelectItem<string>[] {
  const states = supportedStates
    .filter(state => state.countryCode.trim().toLowerCase() === countryCode.trim().toLowerCase())
    .map(state => ({ key: state.name, value: state.code }))
    .sort(sortAlphabeticallyByProps('key'))

  if (addEmptyValue) {
    states.unshift({ key: `${stateCaption}`, value: '' })
  }

  return states
}
